class Breakpoint
{
	public Min: number;
	public Max?: number;

	constructor(min: number, max?: number)
	{
		this.Min = min;

		if (typeof max !== "undefined")
		{
			this.Max = max - 0.2;
		}
	}

	public get IsDown(): boolean
	{
		if (typeof this.Max !== "undefined")
		{
			return window.matchMedia(`(max-width: ${this.Max}px)`).matches;
		}
		else
		{
			return false;
		}
	}

	public get IsMatch(): boolean
	{
		return window.matchMedia(`(min-width: ${this.Min}px) and (max-width: ${this.Max}px)`).matches;
	}

	public get IsUp(): boolean
	{
		return window.matchMedia(`(min-width: ${this.Min}px)`).matches;
	}
}

export class Media
{
	private static MinPoints = {
		Xs: 0,
		Sm: 576,
		Md: 768,
		Lg: 992,
		Xl: 1200,
		Xxl: 1500
	};

	public static Breakpoints = {
		Xs: new Breakpoint(this.MinPoints.Xs, this.MinPoints.Sm),
		Sm: new Breakpoint(this.MinPoints.Sm, this.MinPoints.Md),
		Md: new Breakpoint(this.MinPoints.Md, this.MinPoints.Lg),
		Lg: new Breakpoint(this.MinPoints.Lg, this.MinPoints.Xl),
		Xl: new Breakpoint(this.MinPoints.Xl, this.MinPoints.Xxl),
		Xxl: new Breakpoint(this.MinPoints.Xxl)
	};

	public static MediaMobile = `(max-width: ${this.Breakpoints.Md.Max}px)`;
	public static MediaDesktop = `(min-width: ${this.Breakpoints.Lg.Min}px)`;

	public static get DeviceType(): string
	{
		if (this.Breakpoints.Md.IsDown)
		{
			return "mobile";
		}
		else
		{
			return "desktop";
		}
	}

	public static get IsDesktop(): boolean
	{
		if (this.DeviceType === "desktop")
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	public static get IsMobile(): boolean
	{
		if (this.DeviceType === "mobile")
		{
			return true;
		}
		else
		{
			return false;
		}
	}
}